var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"container",attrs:{"wrap":""}},[_c('textarea-field',{attrs:{"validator":_vm.vs.eventClosed,"label":"Event closed"},model:{value:(_vm.form.eventClosed),callback:function ($$v) {_vm.$set(_vm.form, "eventClosed", $$v)},expression:"form.eventClosed"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }